// src/routes/protected.tsx
import { Navigate, Route, Routes } from 'react-router-dom';
import {BaseRoutes} from "~/apps/base";
import {BaseRoutes as CartarioRoutes} from "~/apps/cartario";
import useAuthentication from "~/hooks/useAuthentication.ts";
import {AppBridgeProvider} from "~/providers/AppBridgeProvider.tsx";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const {getShopifySession} = useAuthentication();
    const session = getShopifySession();

    if (!session) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

const ProtectedRoutes = () => {
    const protectedRoutes = [
        {
            path: '/base/*',
            component: <BaseRoutes />
        },
        {
            path: '/cartario/*',
            component: <CartarioRoutes />
        }
    ]
    return (
        <Routes>
            {protectedRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={<ProtectedRoute><AppBridgeProvider>{route.component}</AppBridgeProvider></ProtectedRoute>} />
            ))}
            <Route path="/*" element={<Navigate to="/errors/404" replace />} />
        </Routes>
    );
};

export default ProtectedRoutes;
